export default __webpack_public_path__ + "static/media/service_middle_intro.e2e1aa0a.mp4";